"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPlaceTypes = function (p) { return (p.placeType !== "region" &&
    p.placeType !== "neighborhood" &&
    p.placeType !== "continent"); };



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-routing/dist/utils/filterPlaceTypes.js
// module id = duHJ
// module chunks = 2